import { createFileRoute } from "@tanstack/react-router";
import { Mehr } from "../features/shell/Mehr";

export const Route = createFileRoute("/mehr")({
  component: Mehr,
});
